import { render, staticRenderFns } from "./ListReturKirimInven.vue?vue&type=template&id=6606c9d2&"
import script from "./ListReturKirimInven.vue?vue&type=script&lang=js&"
export * from "./ListReturKirimInven.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports